'use client';

import type { ReactNode } from 'react';
import { Box } from '@mui/material';

type Props = {
  children: ReactNode;
  className?: string;
};

/** Stacks REQUEST A DEMO above hero resource buttons (desktop/mobile). */
export default function FeatureHeroCtaStack({ children, className }: Props) {
  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
}
